module.exports = __webpack_public_path__ + "img/ogbrown_hair.08ba128d.jpg";